module.exports = "https://trybtryb-legacy.web.app/img/to_left.2b61ee71.svg";